import type { SxProps } from '@mui/material';
import type { ChartProps, ChartOptions } from 'src/components/chart';

import { Box } from '@mui/material';

import { fNumber } from 'src/utils/format-number';

import { EmptyState } from 'src/components/EmptyState';
import { Chart, useChart } from 'src/components/chart';

type StoreSalesChartProps = {
  type?: ChartProps['type'];
  chart: {
    colors?: string[];
    series: {
      data: number[];
    }[];
    options?: ChartOptions;
  };
  sx?: SxProps;
};

export function StoreSalesChart({ type = 'bar', chart, sx }: StoreSalesChartProps) {
  const chartOptions = useChart({
    grid: {
      padding: {
        top: 6,
        left: 6,
        right: 6,
        bottom: 6,
      },
    },
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    tooltip: {
      y: { formatter: (value: number) => fNumber(value), title: { formatter: () => '' } },
    },
    markers: {
      strokeWidth: 0,
    },
    ...chart.options,
  });

  if (!chart.series[0]?.data?.length) {
    return (
      <Box sx={{ height: 300 }}>
        <EmptyState />
      </Box>
    );
  }

  return <Chart type={type} series={chart.series} options={chartOptions} sx={sx} />;
}
